import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import FormHelperText from '@mui/material/FormHelperText';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/FormControl": FormControl, "@mui/material/InputLabel": InputLabel, "@mui/material/Input": Input, "@mui/material/FormHelperText": FormHelperText } } });
export default ClientProvider;
